import React, { useEffect, useState } from "react";
import PropTypes from "prop-types"; // Importar PropTypes
import QRCode from "qrcode";
import logoUpro from "../../../../assets/images/logo.png";
import arca from "../../../../assets/images/arca.png";
import { Grid } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import { valorAPesos } from "utils/formatters";
import dayjs from "dayjs";
import SoftButton from "components/SoftButton";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import SoftBox from "components/SoftBox";
import { makeNiceText } from "utils/formatters";
import { formatMoneyPunto } from "utils/formatters";
import SinDatos from "components/Carteles/SinDatos";
import { gql, useLazyQuery } from "@apollo/client";

const FacturaImpresion = ({ factura, empresa }) => {
  const [qrCodeURL, setQrCodeURL] = useState(null);
  console.log("factura en impresion", factura);

  useEffect(() => {
    if (factura.url) {
      QRCode.toDataURL(factura.url).then((url) => setQrCodeURL(url));
    }
  }, [factura.url]);

  const [getSede, { data: dataSede }] = useLazyQuery(gql`
    query getSede($filter: JSON) {
      sedes(filter: $filter) {
        id
        nombre
        nombreFantasia
        direccion
        cuit
        email
        incioActividades
        ingresosBrutos
        email
      }
    }
  `);

  useEffect(() => {
    if (factura?.pto_vta) {
      getSede({
        variables: {
          filter: {
            ptoVenta: factura?.pto_vta,
          },
        },
      });
    }
  }, [factura]);

  const handlePrint = () => {
    const element = document.getElementById("factura");
    const originalWidth = element.style.width;
    const originalHeight = element.style.height;

    element.style.width = "794px"; // Ancho en píxeles para A4
    element.style.height = "1123px"; // Alto en píxeles para A4
    element.style.overflow = "visible"; // Evita recortes
    setTimeout(() => {
      if (element) {
        html2canvas(element, { scale: 2, scrollY: -window.scrollY }).then((canvas) => {
          const imgData = canvas.toDataURL("image/jpeg", 1);

          const report = new jsPDF({
            orientation: "portrait",
            compress: true,
          });

          const pdfWidth = report.internal.pageSize.getWidth();
          const pdfHeight = report.internal.pageSize.getHeight();

          report.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
          report.save(`Factura ${factura.tipoFactura} - ${factura?.numeroDeFacturaAfip}.pdf`);
          element.style.width = originalWidth;
          element.style.height = originalHeight;
        });
      }
    }, 80);
  };

  return (
    <SoftBox>
      <SoftBox
        sx={{
          display: {
            xs: "none",
            sm: "block",
          },
        }}
      >
        <Grid container direction="column" alignItems="center" p={2}>
          <Grid
            id="factura"
            sx={{
              width: "794px", // A4
              backgroundColor: "#fff",
              padding: 4,
              boxShadow: "0 0 5px rgba(0,0,0,0.2)",
              borderRadius: "8px",
              fontFamily: "Arial, sans-serif",
            }}
          >
            {/* Encabezado */}
            <Grid
              container
              justifyContent="space-between"
              borderBottom="2px solid #000"
              pb={2}
              alignItems="center"
              spacing={2}
            >
              <Grid item xs={6} display="flex" gap={2} alignItems="center">
                <SoftBox>
                  <img src={logoUpro} alt="Logo" style={{ width: "120px" }} />
                </SoftBox>
                <SoftBox display="flex" flexDirection="column">
                  <SoftTypography variant="h6">{dataSede?.sedes[0]?.nombreFantasia}</SoftTypography>
                  <SoftBox display="flex">
                    <SoftTypography variant="caption">Direccion:&nbsp;</SoftTypography>
                    <SoftTypography variant="caption" fontWeight="bold">
                      {dataSede?.sedes[0]?.direccion}
                    </SoftTypography>
                  </SoftBox>
                  <SoftBox display="flex">
                    <SoftTypography variant="caption">CUIT:&nbsp;</SoftTypography>
                    <SoftTypography variant="caption" fontWeight="bold">
                      {dataSede?.sedes[0]?.cuit}
                    </SoftTypography>
                  </SoftBox>
                  <SoftBox display="flex">
                    <SoftTypography variant="caption">Inicio de actividades:&nbsp;</SoftTypography>
                    <SoftTypography variant="caption" fontWeight="bold">
                      {dataSede?.sedes[0]?.inicioActividades}
                    </SoftTypography>
                  </SoftBox>
                  <SoftBox display="flex">
                    <SoftTypography variant="caption">Email:&nbsp;</SoftTypography>
                    <SoftTypography variant="caption" fontWeight="bold">
                      {dataSede?.sedes[0]?.email}
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
              </Grid>
              <Grid item xs={6} display="flex" gap={2} alignItems="center">
                <SoftBox
                  textAlign="center"
                  display="flex"
                  flexDirection="column"
                  px={2}
                  py={1}
                  sx={{
                    border: "1px solid #000",
                    width: "fit-content",
                  }}
                >
                  <SoftTypography variant="h2" fontWeight="bold">
                    {factura?.tipoFactura}
                  </SoftTypography>
                  <SoftTypography variant="caption">{`COD: ${
                    factura?.tipo_cbte?.length === 2
                      ? `0${factura?.tipo_cbte}`
                      : `00${factura?.tipo_cbte}`
                  }`}</SoftTypography>
                </SoftBox>
                <SoftBox display="flex" flexDirection="column">
                  <SoftTypography variant="h6">FACTURA</SoftTypography>

                  <SoftBox display="flex">
                    <SoftTypography variant="caption">N° de comprobante:&nbsp;</SoftTypography>
                    <SoftTypography variant="caption" fontWeight="bold">
                      {factura?.numeroDeFacturaAfip || "Sin número"}
                    </SoftTypography>
                  </SoftBox>
                  <SoftBox display="flex">
                    <SoftTypography variant="caption">Punto de Venta:&nbsp;</SoftTypography>
                    <SoftTypography variant="caption" fontWeight="bold">
                      {factura?.pto_vta || "Sin número"}
                    </SoftTypography>
                  </SoftBox>
                  <SoftBox display="flex">
                    <SoftTypography variant="caption">Fecha de Emisión:&nbsp;</SoftTypography>
                    <SoftTypography variant="caption" fontWeight="bold">
                      {dayjs(factura?.fechaFactura).format("DD/MM/YYYY") || "Sin fecha"}
                    </SoftTypography>
                  </SoftBox>
                  <SoftBox display="flex">
                    <SoftTypography variant="caption">Ingresos Brutos:&nbsp;</SoftTypography>
                    <SoftTypography variant="caption" fontWeight="bold">
                      {dataSede?.sedes[0]?.ingresosBrutos || "Sin especificar"}
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
              </Grid>
            </Grid>

            <SoftBox display="flex" flexDirection="column" my={2}>
              <SoftTypography variant="h6">Datos del cliente</SoftTypography>

              <SoftBox display="flex">
                <SoftTypography variant="caption">Apellido y Nombre:&nbsp;</SoftTypography>
                <SoftTypography variant="caption" fontWeight="bold">
                  {factura?.cliente
                    ? makeNiceText(
                        `${factura.cliente?.apellido}  ${factura.cliente?.nombre}`,
                        "nombre"
                      )
                    : "Consumidor Final"}
                </SoftTypography>
              </SoftBox>
              <SoftBox display="flex">
                <SoftTypography variant="caption">DNI:&nbsp;</SoftTypography>
                <SoftTypography variant="caption" fontWeight="bold">
                  {factura?.nro_doc && factura?.nro_doc !== "0"
                    ? formatMoneyPunto(factura?.nro_doc)
                    : "Sin especificar"}
                </SoftTypography>
              </SoftBox>
              <SoftBox display="flex">
                <SoftTypography variant="caption">Condición frente al IVA:&nbsp;</SoftTypography>
                <SoftTypography variant="caption" fontWeight="bold">
                  Consumidor final
                </SoftTypography>
              </SoftBox>
            </SoftBox>

            {/* Tabla de productos */}
            <Grid container mt={1} border="1px solid #ccc">
              <Grid container style={{ backgroundColor: "#f5f5f5", padding: "8px" }}>
                <Grid item xs={2}>
                  <SoftTypography variant="h6" fontWeight="bold">
                    Cantidad
                  </SoftTypography>
                </Grid>
                <Grid item xs={6}>
                  <SoftTypography variant="h6" fontWeight="bold">
                    Descripción
                  </SoftTypography>
                </Grid>
                <Grid item xs={4} textAlign="right">
                  <SoftTypography variant="h6" fontWeight="bold">
                    Importe
                  </SoftTypography>
                </Grid>
              </Grid>

              {factura.pedido?.detalles?.map((detalle, index) => (
                <Grid
                  container
                  key={index}
                  style={{ padding: "6px 8px", borderTop: "1px dashed #ccc" }}
                >
                  <Grid item xs={2}>
                    <SoftTypography variant="h6" fontWeight="regular">
                      {detalle.cantidad}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={6}>
                    <SoftTypography variant="h6" fontWeight="regular">
                      {detalle.producto?.nombre}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={4} textAlign="right">
                    <SoftTypography variant="h6" fontWeight="regular">
                      {valorAPesos(detalle.precio * detalle.cantidad)}
                    </SoftTypography>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            {/* QR y CAE */}
            <SoftBox display="flex" justifyContent="space-between" mt={2}>
              <SoftBox display="flex" gap={2} alignItems="center">
                {qrCodeURL && (
                  <SoftBox display="flex" flexDirection="column" alignItems="center">
                    <img
                      src={qrCodeURL}
                      alt="QR Code"
                      style={{ width: "120px", height: "120px" }}
                    />
                    <img
                      src={arca}
                      alt="arca logo"
                      style={{ width: "100px", height: "40px", marginTop: "8px" }}
                    />
                  </SoftBox>
                )}
                <SoftBox display="flex" flexDirection="column" alignItems="flex-start" gap={1}>
                  <SoftTypography variant="h7">
                    <strong>CAE:</strong> {factura?.CAE || "Sin CAE"}
                  </SoftTypography>
                  <SoftTypography variant="h7">
                    <strong>Fecha de vto CAE:</strong>{" "}
                    {factura.CAEFchVto
                      ? dayjs(factura.CAEFchVto).format("DD/MM/YYYY")
                      : "Sin fecha"}
                  </SoftTypography>
                  <SoftBox
                    p={1}
                    border="1px solid #000"
                    display="flex"
                    flexDirection="column"
                    gap={1}
                  >
                    <SoftTypography variant="caption">
                      Régimen de Transparencia Fiscal al Consumidor (Ley 27.743)
                    </SoftTypography>
                    <SoftTypography variant="caption">
                      IVA Contenido:{" "}
                      <strong>
                        {factura?.imp_iva21 ? valorAPesos(factura?.imp_iva21) : `$0,00`}
                      </strong>
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
              </SoftBox>
              <SoftBox display="flex" flexDirection="column" alignItems="flex-end" mt={2} gap={1}>
                <SoftTypography variant="h7">
                  <strong>Descuento:</strong> {valorAPesos(factura.descuento)}
                </SoftTypography>
                <SoftTypography variant="h7">
                  <strong>Recargo:</strong> {valorAPesos(factura.recargo)}
                </SoftTypography>
                <SoftTypography variant="h6">
                  <strong>Total:</strong> {valorAPesos(factura.total)}
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          </Grid>

          <SoftBox mt={2}>
            <SoftButton onClick={handlePrint} circular color="uproGreen">
              Descargar PDF
            </SoftButton>
          </SoftBox>
        </Grid>
      </SoftBox>
      <SoftBox
        sx={{
          display: {
            xs: "block",
            sm: "none",
          },
        }}
      >
        <SinDatos
          titulo="Funcionalidad no disponible"
          mensaje="La funcionalidad de impresión solo está disponible en la versión de escritorio."
          icono="print"
        />
      </SoftBox>
    </SoftBox>
  );
};

// PropTypes para validar las props
FacturaImpresion.propTypes = {
  factura: PropTypes.object,
  empresa: PropTypes.object,
};

export default FacturaImpresion;
